import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader } from "../common/Loader";

const VerifyUser = () => {
  const location = useLocation();
  const queryParameters = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const VerifingUser = async () => {
    let payload = JSON.stringify({
      token: queryParameters.get("token"),
      email: queryParameters.get("email"),
      country: queryParameters.get("country_code"),
    });
    try {
      const baseUrl = payload.country === 'UAE' ? 'https://onboardifyapi.uae.tasc360.com/common/verifyUser': 'https://onboardifyapi.ksa.tasc360.com/common/verifyUser'
      setLoading(true);
      // const response = await loginApi(payload);
      const response = await fetch(baseUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // Specify the content type
        },
        body: payload, // Convert payload to JSON string
      });
      
      if (!response.ok) {
        // Handle HTTP errors
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const newResponse = await response.json();
      if(newResponse.status){
        setTimeout(() => {
                navigate('/');
            }, 2000)
      }

    }catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    VerifingUser();
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <div className="inc-verify-user">
        <div>User Verified Successfully, Redirecting to the login Page.</div>
      </div>
    </>
  );
};

export default VerifyUser;